import RouteView from '@/router/RouteView.vue';
import Courseware from '@/views/BranchSchool/courseware.vue';
import Teacher from './index.vue';
import Statistics from './statistics.vue';
import Detail from '../Statistical/StatisticalClass.vue';

export default [
  {
    path: '/teacher',
    name: 'Teacher',
    component: RouteView,
    redirect: '/teacher/list',
    meta: {
      title: '老师管理',
    },
    children: [
      {
        path: '/teacher/list',
        name: 'TeacherList',
        component: Teacher,
        meta: {
          title: '老师列表',
        },
      },
      {
        path: '/teacher/courseware/:id',
        name: 'Courseware',
        component: Courseware,
        meta: {
          title: '授权课件',
        },
      },
      {
        path: '/teacher/statistics/:id',
        name: 'Statistics2',
        component: Statistics,
        meta: {
          title: '上课统计',
        },
      },
      {
        path: '/teacher/statistics/detail/:id',
        name: 'teacherStatisticsDetail',
        component: Detail,
        meta: {
          title: '日志详情',
        },
      },
    ],
  },
];




// WEBPACK FOOTER //
// ./src/views/Teacher/index.js